import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import type { Role } from '@/types/user';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = {
  roleId: string;
};

export const getRoleDetails = async (
  scope: RequestScope,
  { roleId }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Role>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<Role>>(`/organization/role/${roleId}`, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
